<form
    novalidate
    #propertyOpenHomeTimesSectionForm="ngForm"
    *ngIf="draftLoaded$ | async"
>
    <tg-row>
        <tg-col>
            <h2>Open home times</h2>
        </tg-col>
    </tg-row>
    <tg-row
        *ngIf="openHomeTimes.length > 0"
        class="property-open-home-times-section__open-home-time-rows-container"
    >
        <tg-col sm="12" md="9" lg="6">
            <ul tgList2 type="ruled">
                <li
                    class="
                        property-open-home-times-section__open-home-time-row
                        property-open-home-times-section__open-home-time-row--ruled
                    "
                    *ngFor="let o of openHomeTimes; index as i"
                >
                    <label
                        class="
                            property-open-home-times-section__open-home-time-row-label
                        "
                    >
                        <span
                            class="
                                o-input__body-prefix
                                property-open-home-times-section__o-input__body-prefix
                            "
                            [hidden]="isValidItem(i)"
                        >
                            <tg-icon
                                alt="Invalid"
                                size="small"
                                name="basic-warning"
                            >
                            </tg-icon>
                        </span>
                        <span
                            class="o-input__body-primary"
                            [ngClass]="{
                                'property-open-home-times-section__open-home-time-row--invalid':
                                    !isValidItem(i)
                            }"
                        >
                            {{ o.date | date: 'dd/MM/yyyy' }},
                            {{ o.startTime | tmTimeFromNumber }} -
                            {{ o.endTime | tmTimeFromNumber }}
                        </span>
                        <span
                            class="
                                o-input__body-suffix
                                property-open-home-times-section__o-input__body-suffix
                            "
                        >
                            <tg-icon
                                alt="Remove"
                                size="small"
                                name="basic-cross-framed"
                                class="
                                    property-open-home-times-section__o-input__body-suffix-icon
                                "
                                (click)="removeItem(i)"
                            >
                            </tg-icon>
                        </span>
                    </label>
                </li>
            </ul>
        </tg-col>
    </tg-row>
    <tg-row *ngIf="hasInvalidItem()">
        <tg-col>
            <p
                class="property-open-home-times-section__validate-fail"
                *ngIf="allowToAdd"
            >
                <label *ngFor="let e of getErrorMessages()">{{ e }}</label>
            </p>
            <p
                class="property-open-home-times-section__validate-fail"
                *ngIf="!allowToAdd"
            >
                {{ cannotAddOpenHomeWithoutAnAddressErrorMessage }}
            </p>
        </tg-col>
    </tg-row>
    <tg-row *ngIf="!exceedMax">
        <tg-col sm="12" md="9" lg="6">
            <tg-row class="property-open-home-times-section__form-row">
                <tg-col sm="12" md="6"
                    ><tm-date
                        name="openHomeDate"
                        inputReadonly
                        [required]="true"
                        [hideOptionalLabel]="true"
                        [hasError]="openHomeDateHasError"
                        [minDate]="minDate"
                        [maxDate]="maxDate"
                        [selectedDate]="openHomeDate"
                        (dateChange)="onDateChange($event)"
                        [validation]="{
                            errors: {
                                required: {
                                    message: 'Please select a date'
                                }
                            }
                        }"
                        [disabled]="!allowToAdd"
                    ></tm-date
                ></tg-col>
                <tg-col sm="6" md="3">
                    <tg-select-container
                        class="hide-optional-label"
                        label="Start time"
                        [class.o-select-container--invalid]="
                            openHomeStartTimeHasError
                        "
                    >
                        <select
                            tgSelect
                            name="openHomeStartTime"
                            [(ngModel)]="openHomeStartTime"
                            [validation]="{
                                required: {
                                    message: 'Please select start time'
                                }
                            }"
                            [disabled]="!allowToAdd"
                            (change)="onOpenStartTimeChange()"
                        >
                            <option [ngValue]="0" selected></option>
                            <option
                                *ngFor="let o of metadata.openHomeTimes"
                                [ngValue]="o.value"
                            >
                                {{ o.display }}
                            </option>
                        </select>
                    </tg-select-container>
                </tg-col>
                <tg-col sm="6" md="3">
                    <tg-select-container
                        class="hide-optional-label"
                        label="End time"
                        [class.o-select-container--invalid]="
                            openHomeEndTimeHasError
                        "
                    >
                        <select
                            tgSelect
                            name="openHomeEndTime"
                            [(ngModel)]="openHomeEndTime"
                            [validation]="{
                                required: {
                                    message: 'Please select end time'
                                }
                            }"
                            [disabled]="!allowToAdd"
                            (change)="onOpenStartEndChange()"
                        >
                            <option [ngValue]="0" selected></option>
                            <option
                                *ngFor="let o of metadata.openHomeTimes"
                                [ngValue]="o.value"
                            >
                                {{ o.display }}
                            </option>
                        </select>
                    </tg-select-container>
                </tg-col>
            </tg-row>
            <tg-row
                class="
                    property-open-home-times-section__form-row
                    property-open-home-times-section__form-row--no-padding-top
                "
                *ngIf="hasError"
            >
                <tg-col>
                    <p class="property-open-home-times-section__validate-fail">
                        {{ errorMessage }}
                    </p>
                </tg-col>
            </tg-row>
            <tg-row
                class="
                    property-open-home-times-section__form-row
                    property-open-home-times-section__form-row--no-padding-top
                "
                *ngIf="allowToAdd"
            >
                <tg-col sm="12" md="6">
                    <button
                        tgButton2
                        fullWidth
                        (click)="onAddOpenHomeTimeClick()"
                    >
                        Add open home time
                    </button>
                </tg-col>
            </tg-row>
            <tg-row
                class="
                    property-open-home-times-section__form-row
                    property-open-home-times-section__form-row--no-padding-top
                "
                *ngIf="!allowToAdd"
            >
                <tg-col>
                    <tg-info-box tgStyle="primary">
                        Please provide a full address to add open home times
                    </tg-info-box>
                </tg-col>
            </tg-row>
        </tg-col>
    </tg-row>
</form>
